import { defineMessages } from 'react-intl'

const scope = `modules.expense.features.getExpense.views.expenseReportDetailSummary`

export default defineMessages({
  reportHeaderTitle: {
    id: `${scope}.reportHeaderTitle`,
    defaultMessage: 'Expense report #{id} - {title}',
  },
  requestedByLabel: {
    id: `${scope}.requestedByLabel`,
    defaultMessage: 'Requested by',
  },
  locationLabel: {
    id: `${scope}.locationLabel`,
    defaultMessage: '{singularPrimaryOrgCategoryLabel}',
  },
  departmentLabel: {
    id: `${scope}.departmentLabel`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  submittedLabel: {
    id: `${scope}.submittedLabel`,
    defaultMessage: 'Submitted',
  },
  lastModifiedLabel: {
    id: `${scope}.lastModifiedLabel`,
    defaultMessage: 'Last modified',
  },
  nextApproverLabel: {
    id: `${scope}.nextApproverLabel`,
    defaultMessage: 'Next approver',
  },
  travelTicketLabel: {
    id: `${scope}.travelTicketLabel`,
    defaultMessage: 'Travel ticket',
  },
  travelTicketValue: {
    id: `${scope}.travelTicketValue`,
    defaultMessage: 'Travel #{id} - {purpose}',
  },
  statusBadgeApproved: {
    id: `${scope}.statusBadgeApproved`,
    defaultMessage: 'Approved',
  },
  statusBadgeDenied: {
    id: `${scope}.statusBadgeDenied`,
    defaultMessage: 'Denied',
  },
  descriptionHeading: {
    id: `${scope}.descriptionHeading`,
    defaultMessage: 'Description',
  },
  subtotalLabel: {
    id: `${scope}.subtotalLabel`,
    defaultMessage: 'Subtotal',
  },
  taxTotalLabel: {
    id: `${scope}.taxTotalLabel`,
    defaultMessage: 'Tax',
  },
  reimbursableLabel: {
    id: `${scope}.reimbursableLabel`,
    defaultMessage: 'Reimbursable',
  },
  totalLabel: {
    id: `${scope}.totalLabel`,
    defaultMessage: 'Total',
  },
  noPurposeSpecified: {
    id: `${scope}.noPurposeSpecified`,
    defaultMessage: 'No purpose specified',
  },
  requestSummaryHeader: {
    id: `${scope}.requestSummaryHeader`,
    defaultMessage: 'Request summary',
  },
  approvalSummaryHeader: {
    id: `${scope}.approvalSummaryHeader`,
    defaultMessage: 'Approval summary',
  },
})
